import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import Environment from '@di-shared/features/environment/Environment';
import EvBatteryPerformaceBottomSheetEU from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryPerformaceBottomSheetEU';
import EvBatteryPerformanceBottomSheetNa from '@di-shared/features/home/na/ev-battery/EvBatteryPerformanceBottomSheet.na';
import EvBatteryPerformaceBottomSheetKR from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryPerformaceBottomSheetKR';
import {EvBatteryPerformanceStatus} from '@di-shared/features/home/kr/ev-battery/monitor/const';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function EvBatteryPerformaceBottomSheetPage() {
  const {t} = useInferableTranslation();
  const evBatteryPerformanceStatus = window.data.evBatteryPerformanceStatus as unknown as EvBatteryPerformanceStatus;
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <>
        <Environment.Kr>
          <EvBatteryPerformaceBottomSheetKR
            brandName={t('T30471')}
            evBatteryPerformanceStatus={evBatteryPerformanceStatus}
            onExit={() => window.bottomSheetClose(null)}
          />
        </Environment.Kr>
        <Environment.Eu>
          <EvBatteryPerformaceBottomSheetEU
            brandName={t('T30471')}
            evBatteryPerformanceStatus={evBatteryPerformanceStatus}
            onExit={() => window.bottomSheetClose(null)}
          />
        </Environment.Eu>
        <Environment.Na>
          <EvBatteryPerformanceBottomSheetNa
            brandName={t('T30471')}
            evBatteryPerformanceStatus={evBatteryPerformanceStatus}
            onExit={() => window.bottomSheetClose(null)}
          />
        </Environment.Na>
      </>
    </BottomSheetWebViewWrapper>
  );
}

export default EvBatteryPerformaceBottomSheetPage;
